import {useContext, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {toast} from 'react-toastify'

import {Box} from '@mui/material'
import {GlobalContext} from '../../../../../App'
import DynamicList from './DynamicList'
import HeatCircleMap from '../../HeatCircleMap'

interface IDynamicParams {
  isDisplayed?: boolean
  maps?: any[]
}

interface ITempProps {
  date: Date
  action: string
  idPessoa: number
}

export const DynamicMap = ({isDisplayed, maps}: IDynamicParams) => {
  const globalContext: any = useContext(GlobalContext)
  const {accesscode, sysparam} = useParams()

  const [markers, setMarkers] = useState<any[]>([]) // pode tipar com IMarker[] também se quiser

  function BuildControls() {
    if (!isDisplayed) {
      return
    }
    globalContext.ReactState.Toolbar2.setControls([])
  }

  useEffect(() => {
    toast.dismiss()
    BuildControls()
  }, [isDisplayed])

  useEffect(() => {
    console.log('Markers:', maps)
  }, [maps])

    return (
      <Box sx={{height: window.location.href.includes('_dynamicTabs') ? 'calc(100vh - 200px)' : 'calc(100vh - 130px)', width: '100%'}}>
        {maps && maps?.length > 0 && <HeatCircleMap markers={maps} />}
      </Box>
    )
  
}
